import IconBox from '../../components/common/icon-box'
import InfoMessage from '../../components/common/info-message'
import { useTranslation } from '../../useTranslation'
import Button from '../../components/common/button'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

const InvalidToken = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    return (
        <IconBox icon="address-card">
            <div className="py-10 px-2">
                <InfoMessage type="error" label={t('tokenExpired')} icon="check" />
                <div className="flex justify-center mt-7 gap-3">
                    <Button type={'squareYellow'} icon="chevron-left" text={t('back')} onClick={() => navigate(-1)} />
                    <Link to="/">
                        <Button text={t('backToRingo')} type="squareBlue" />
                    </Link>
                </div>
            </div>
        </IconBox>
    )
}

export default InvalidToken
